import App from 'app/app.js';
import 'app/store/ContentStore.js';
import 'app/directive/LtCardOffersDirective.js';

function LtCardOffersCtrl($scope, ActiveJobChangedAction, ChangeActiveOrderAction, ContentChangeAction, ContentStore) {
  this.cardItems = [];

  this.loadContent = function () {
    var zone = 'MOBILE_TRANS_MY_CARD_OFFERS';
    var bannerTwoImgKey = ContentStore.appendLogin('IMAGE_2');
    var bannerTwoCopyKey = ContentStore.appendLogin('COPY_2');

    var bannerOneImg = ContentStore.getContent(zone, 'IMAGE_1');
    var bannerTwoImg = ContentStore.getContent(zone, bannerTwoImgKey);

    this.cardItems = [];

    if (bannerOneImg) {
      this.cardItems.push({
        imgSrc: ContentStore.resolveContentImagePath(bannerOneImg),
        copyCode: 'COPY_1'
      });
    }
    if (bannerTwoImg) {
      this.cardItems.push({
        imgSrc: ContentStore.resolveContentImagePath(bannerTwoImg),
        copyCode: bannerTwoCopyKey
      });
    }

    $scope.onChange({ cardOffersPresent: this.cardItems.length > 0 });
  };

  ActiveJobChangedAction.register(this.loadContent.bind(this));
  ChangeActiveOrderAction.register(this.loadContent.bind(this));
  ContentChangeAction.register(this.loadContent.bind(this));

  this.loadContent();
}

App.controller('LtCardOffersCtrl', [
  '$scope',
  'ActiveJobChangedAction',
  'ChangeActiveOrderAction',
  'ContentChangeAction',
  'ContentStore',
  LtCardOffersCtrl
]);
